module.exports = __webpack_public_path__ + "img/Weapon_295.92e7fb12.png";